import { render } from "./DashboardCards.vue?vue&type=template&id=b8a676ea&scoped=true"
import script from "./DashboardCards.vue?vue&type=script&lang=js"
export * from "./DashboardCards.vue?vue&type=script&lang=js"

import "./DashboardCards.vue?vue&type=style&index=0&id=b8a676ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8a676ea"

export default script